























































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ActivitySchema } from "@/models/activity_schema";
import ActivityService from "../../services/activity_service";
import CustomerService from "@/services/customer_service";
import Datepicker from "vuejs-datepicker";
import { EventBus } from "@/events/index";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import { Validation } from "vuelidate";
import { ActivityResults, ActivityMethods } from "@/models/activity";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
import { StoreModule } from "@/store/types";
import { CustomerGetters } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import {CustomerSchema} from "@/models/customer_schema";
import { AuthError, APIError, GenericError } from "@/services/error_service";

@Component({
  components: {
    Datepicker,
    VueTimepicker,
  },
})
export default class ModalActivityNote extends Vue {
  @Prop() isEdit!: boolean;
  @Prop() data!: ActivitySchema;
  @Prop() customerId!: string;
  protected ActivityResults = ActivityResults;
  protected ActivityMethods = ActivityMethods;
  protected formData = {} as ActivitySchema;
  protected date = "";
  protected time = "";
  protected activityService = new ActivityService();
  protected customerService = new CustomerService();
  protected $v: Validation;
  protected repView = false;
  protected selected = {} as CustomerSchema;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;

  created() {
    if (this.$route.name === "reps") {
      this.repView = true;
    }
    if (this.isEdit) {
      this.formData = { ...this.data } as ActivitySchema;
      this.getDate(this.formData.contacted_at);
      if (this.repView) {
        this.selected = { _id: this.customerId } as CustomerSchema;
      }
    } else {
      const now = moment(new Date()).format();
      this.getDate(now);
    }
  }

  @Validations()
  validations() {
    return {
      formData: {
        method: { required },
        contact_name: { required },
        result: { required },
      },
      date: { required },
      time: { required },
    };
  }

  get filteredCustomers(): CustomerSchema[] {
    let customers = this.customers;
    if (this.$route.query.region) {
      customers = this.customers.filter((customer) => {
        return customer.sales_region === this.$route.query.region;
      });
    }
    return customers;
  }

  public makeSentenceCase(option: string) {
    return option.charAt(0).toUpperCase() + option.slice(1);
  }

  public getDate(date: string): void {
    this.time = moment(date).format("hh:mm AA");
    const dateFormatted = moment(date).format("YYYY-DD-MM") // formatting like this so we can drop time, time is stored in a separate variable
    this.date = moment(dateFormatted, 'YYYY-DD-MM').toISOString();
  }

  public handleSubmit(): void {
    this.$v.formData.$touch();
    if (!this.$v.$invalid) {
      this.submit();
    }
  }

  public formatDate(): string {
    const formattedDate = moment(this.date).format("YYYY-DD-MM");
    const date = moment(formattedDate + ', ' + this.time, 'YYYY-DD-MM, hh:mm A').toISOString();
    return date;
  }
  /**
   * Routes API request to PUT or POST depending on instance variable 'isEdit'
   * update request sends in the id of the activity note
   * post request sending in the id of the customer, returns id of activity note
   */
  public async submit(): Promise<void> {
    this.formData.contacted_at = this.formatDate();
    if (this.isEdit) {
      if (this.repView) {
        this.formData.customer = this.selected._id;
      }
      try {
        await this.activityService.updateActivity(
          this.formData,
          this.formData._id
        );
        EventBus.$emit("submittedActivity", this.formData, false);
        this.$emit("close");
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        } else if (err instanceof APIError) {
          APIError.popup(err.message);
        } else {
          GenericError.popup(err.message);
        }
      }
    } else {
      try {
        let reqId = this.customerId;
        if (this.repView) {
          reqId = this.selected._id;
          this.formData.customer = this.selected._id;
        }
        const res = await this.customerService.createNewActivity(
          this.formData,
          reqId
        );
        EventBus.$emit("submittedActivity", res, true);
        this.$emit("close");
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        } else if (err instanceof APIError) {
          APIError.popup(err.message);
        } else {
          GenericError.popup(err.message);
        }
      }
    }
  }
}
